export type ConsentChoice = 'granted' | 'denied'

const STORAGE_KEY = 'shelters_cookie_consent'

export const getStoredConsent = (): ConsentChoice | null => {
  if (typeof window === 'undefined') return null
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    return value === 'granted' || value === 'denied' ? value : null
  } catch {
    return null
  }
}

export const storeConsent = (choice: ConsentChoice) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, choice)
  } catch {
    // Storage may be unavailable (private mode, blocked cookies) — ignore.
  }
}
